import type { RouterInputs, RouterOutputs } from "@/trpc";

export type ScreeningScope = RouterInputs["psv"]["getProviderScreenings"];
export type ProviderScreening =
  RouterOutputs["psv"]["getProviderScreenings"]["screenings"][number];
export type LatestScreening = NonNullable<ProviderScreening["latest"]>;
export type ScreeningResult = NonNullable<LatestScreening["result"]>;
export type ScreeningCandidate = ScreeningResult["facts"]["candidates"][number];

/** A screening issue on a run report item, labeled against earlier runs. */
export type ReportIssue =
  RouterOutputs["psv"]["getRun"]["items"][number]["issues"][number];

export const ACTIVE_SCREENING_POLL_MS = 3000;

export function isActiveScreening(latest: ProviderScreening["latest"]) {
  return (
    latest?.status === "queued" ||
    latest?.status === "running" ||
    latest?.status === "retry-wait"
  );
}
